<template>
  <div class="top-bar-skeleton">
    <div class="skeleton-rect logo-placeholder"></div>

    <div class="skeleton-rect nav-link-placeholder"></div>
    <div class="skeleton-rect nav-link-placeholder"></div>
    <div class="skeleton-rect nav-link-placeholder"></div>
    <div class="spacer"></div>

    <div class="skeleton-rect short-rect"></div>
    <div class="skeleton-rect short-rect"></div>

    <div class="skeleton-rect wallet-connect-placeholder"></div>
  </div>
</template>

<script setup></script>

<style scoped>
.top-bar-skeleton {
  display: flex;
  align-items: center;
  height: 64px;
  width: 100%;
}

.spacer {
  flex: 1;
}

.skeleton-rect {
  position: relative;
  overflow: hidden;
  background-color: #2c2c2c;
  border-radius: 4px;
}

.logo-placeholder {
  width: 187px;
  height: 30px;
  margin-right: 16px;
}

.nav-link-placeholder {
  width: 80px;
  height: 20px;
  margin-right: 16px;
}

.short-rect {
  width: 70px;
  height: 36px;
  margin-right: 16px;
}

.wallet-connect-placeholder {
  width: 140px;
  height: 36px;
}
.skeleton-rect {
  animation: skeleton-loading 1.5s ease-in-out infinite;
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
</style>
